import React from "react";
import ReactCompareImage from "react-compare-image";
import originalImage from "./sa.png";
import modifiedImage from "./sa22.png";
import originalImage1 from "./morning.jpeg";
import modifiedImage1 from "./night1.jpeg";
import SliderBackgroundImg from "./SliderBackImg.jpeg";
import { Stack, Box } from "@mui/material";
import PulseAnimation2 from "./PulseAnimation2";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";

const SliderComponent = () => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: {
          xs: "100%", // Adjust for extra small screens
          sm: "100%", // Adjust for small screens
          md: "100%", // Medium screens
          lg: "100%", // Large screens
          xl: "100%", // Extra-large screens
        },
        // border: "1px solid red",
        padding: { xs: "0px", sm: "0px" }, // Add padding for small screens
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          position: "relative", // Ensure relative positioning for layering
          // backgroundImage: `url(${SliderBackgroundImg})`, // Set the background image
          // backgroundSize: "cover", // Make sure the image covers the container
          // backgroundPosition: "center", // Center the background image
          // backgroundRepeat: "no-repeat", // Prevent tiling
        }}
      >
        <ReactCompareSlider
          style={{ height: "100%", width: "100%" }}
          itemOne={
            <ReactCompareSliderImage
              src={originalImage}
              srcSet={originalImage}
              alt="Image one"
              style={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
                // backgroundColor: "blue",
              }}
            />
          }
          itemTwo={
            <ReactCompareSliderImage
              src={modifiedImage}
              srcSet={modifiedImage}
              alt="Image two"
              style={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
                // backgroundColor: "green",
              }}
            />
          }
          handle={<PulseAnimation2 />} // Pass the custom handle here
        //  handle={<>tt</>} // Pass the custom handle here
        />
      </Box>
    </Stack>
  );
};

export default SliderComponent;
